import React, { useEffect, useState, useMemo } from "react";
import { useHistory,useLocation  } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { TopupMyAccountStatusCssClasses } from "../TopupMyAccountsUIHelpers";
import * as actions from "../../../_redux/topupMyAccounts/topupMyAccountsActions";
import { useTopupMyAccountsUIContext } from "../TopupMyAccountsUIContext";
import { GUID } from "../../../../../../_utils/Axios";
import { FormattedMessage,useIntl } from "react-intl";
import { initialization } from "../../../../UserProfile/_redux/Profile/profileActions";
import { GetNasPaidStatus } from "../../../_redux/rechargeLines/rechargeLinesActions";

export function BestOfferForYouActivation({ id, show, onHide }) {
  // TopupMyAccounts UI Context
  const topupMyAccountsUIContext = useTopupMyAccountsUIContext();
  const topupMyAccountsUIProps = useMemo(() => {
    return {
      ids: topupMyAccountsUIContext.ids,
      setIds: topupMyAccountsUIContext.setIds,
      queryParams: topupMyAccountsUIContext.queryParams,
    };
  }, [topupMyAccountsUIContext]);

  // TopupMyAccounts Redux state
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
 
  
  const { topupMyAccounts, isLoading } = useSelector(
    (state) => ({
      isLoading: state.topupMyAccounts.actionsLoading,
    }),
    shallowEqual
  );
 const intl = useIntl()
  // if there weren't selected topupMyAccounts we should close modal
  useEffect(() => {
    // if (id) {
    //    onHide();
    // }
       const init = async () => {
      dispatch(initialization());
     const fixedUrl = window.location.href.replace(/&amp;/g, '&');
       const searchParams = new URL(fixedUrl).searchParams;
      const externalId = searchParams.get("externalId")?.split("?")[0];
      if (externalId) {
        console.log("externalUd",externalId)
        await dispatch(GetNasPaidStatus({ id: externalId }));
        history.push("/my-korek/topup-my-account");
      }
    };

    init();

  }, []);

  
 
  
  const { currentState } = useSelector(
    (state) => ({ currentState: state.topupMyAccounts }),
    shallowEqual
  );
  const { accountItems,bestOffersForYou } = currentState;
  const [status, setStatus] = useState(0);
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);  


 
  const selectedOffer = bestOffersForYou?.list?.find(x => x.idData === id);
  const state = useSelector((state) => state);
  console.log("Redux statewww:", state);    
  const paymentMethods = useSelector(
   (state) => state.profileSlice?.paymentMethodsFees ?? [],
   shallowEqual
 );


  const updateStatus = () => {
   let url = window.location.href;

  if (url.includes("activate-best-offer/")) {
    // Keep only part before "activate-best-offer/"
    url = url.split("activate-best-offer/")[0];
  }
    let params = {
      idData: id,
      idOfferType: 2,
      idRequest: bestOffersForYou && bestOffersForYou.list.filter(x=>x.idData == id)[0].idRequest.toString(),
      offerPrice: bestOffersForYou && bestOffersForYou.list.filter(x=>x.idData == id)[0].priceFloat.toString(),
      offerName:bestOffersForYou && bestOffersForYou.list.filter(x=>x.idData == id)[0].name,
      paymentType: selectedPaymentMethod,
      webRedirectUrl:url
    };
    // console.log(params);
    // server request for updateing topupMyAccount by ids
    dispatch(actions.activateOffer(params)).then(
      () => {
        // refresh list after deletion
        dispatch(actions.fetchMyTopupMyAccounts()).then(
          () => {
            // clear selections list
            // topupMyAccountsUIProps.setIds([]);
            // closing delete modal
            
          
            onHide();
          }
        );
      }
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
         <FormattedMessage id="TOP_UP.BEST_OF_FOR_YOU.ACT"></FormattedMessage>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overlay overlay-block cursor-default">
        {isLoading && (
          <div className="overlay-layer bg-transparent">
            <div className="spinner spinner-lg spinner-warning" />
          </div>
        )}
        {/* <FormattedMessage id="TOP_UP.BEST_OF_FOR_YOU.CONF"></FormattedMessage> */}
        <h4 className="text-center d-block"><FormattedMessage id="TOP_UP.BEST_OF_FOR_YOU.PAYM"></FormattedMessage></h4>
        <div className="text-center d-block" style={{marginBottom:"13px"}}><FormattedMessage id="TOP_UP.BEST_OF_FOR_YOU.TOTALPAY"></FormattedMessage><b>  {selectedOffer?.price?.toString() || ""} </b></div> 
     
       {paymentMethods && paymentMethods.map((method) => (
<div key={method.idPaymentMethod} style={{width:"200px",margin:"8px auto",fontWeight:"600",fontSize:"1rem",fontStyle:"italic" }} className="cursor-pointer">
          <label className="payRadio">
            <input
              type="radio"
              name="paymentMethod"
              value={method.idMapping}
              checked={selectedPaymentMethod === method.idMapping}
              onChange={(e) => setSelectedPaymentMethod(Number(e.target.value))}
              style={{ marginRight: "8px" }}
            />
            {method.methodName}
          </label>
        </div>
))} 

      </Modal.Body>
      <Modal.Footer className="form justify-content-center">
        <div className="form-group">
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            <FormattedMessage id="RECHARGE.CANCEL"></FormattedMessage>
          </button>
          <> </>
          <button
            type="button"
            onClick={updateStatus}
            disabled={!selectedPaymentMethod}
            className="btn btn-warning btn-elevate"
          >
            <b><FormattedMessage id="TOP_UP.ACTIVATE_OFFER"></FormattedMessage></b>
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
